<template>
  <div align="center" class="container-fluid">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />
      {{ $t("currlocation") }}:
      <router-link :to="{ name: 'login' }">{{ $t("index") }}</router-link>
      <img src="../../assets/img/jt.gif" /><a href="javascript:history.go(-1)">{{ $t("anonymou_currpage") }}</a>
      <img src="../../assets/img/jt.gif" />{{ $t("anonymoudetail_title") }}
    </div>
    <div style="min-height: 450px;">
      <table-no-record v-if="records.length == 0"></table-no-record>
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <!--DWLayoutTable-->
        <tr class="trtitle">
          <td width="15%" height="20" valign="middle">
            {{ $t("company_masterno") }}
          </td>
          <td width="8%">
            {{ $t("anonymou_orgn_code") }}
          </td>
          <td width="8%">
            {{ $t("anonymou_dest_code") }}
          </td>
          <td width="8%">
            {{ $t("anonymou_qty") }}
          </td>
          <td width="8%">
            {{ $t("anonymou_gw") }}
          </td>
          <td width="8%">
            {{ $t("anonymou_vw") }}
          </td>
          <td width="8%">
            {{ $t("company_consol_detail") }}
          </td>
          <td width="8%">
            {{ $t("document_word1") }}
          </td>
          <td>
            {{ $t("normal_word5") }}
          </td>
        </tr>
        <tr v-for="(item,i)  in records" :key="i" class="tr1" onmouseover="this.className='shen'" onmouseout="this.className='tr1'">
          <td><a @click="masterNo(item)"> {{item.masterNo}}</a></td>
          <td>{{item.orgnCode}}</td>
          <td>{{item.destCode}}</td>
          <td>{{item.qty}}</td>
          <td>{{item.gw}}</td>
          <td><span v-if="mainInfo.AwbBlType=='S'">{{item.cbm}}</span> <span v-if="mainInfo.AwbBlType=='A'">{{item.vw}}</span></td>
          <td> <a @click="details(item)"> {{ $t("anonymou_detail") }} </a></td>
          <td><a>{{ $t("document_word2") }} </a> &nbsp;|&nbsp; <a>{{ $t("document_word3") }} </a></td>
          <td>
            <state-code :stateCode="item.stateCode" :stateCodeSource="stateCodeSource"></state-code>
          </td>
        </tr>
      </table>

      <pagination v-if="records.length > 0" :total="total" @current-change="changePage" :pageSize="50" :current-page="currentPage"></pagination>
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import TableNoRecord from "@/components/infrastructure/table/table-no-record.vue";
import Pagination from "@/components/infrastructure/pagination/index.vue";
import { getBillOfLadingRecordDetail } from "@/api/airwayBill";
import { SelectBranchBillOfLading } from "@/api/branchBillOflading";
import StateCode from "@/components/infrastructure/layout/state-code.vue";
import { mapActions } from "vuex";
export default {
  components: {
    PageHeader,
    PageFooter,
    TableNoRecord,
    Pagination,
    StateCode,
  },
  data() {
    return {
      mainInfo: {},
      records: {},
      total: 0,
      currentPage: 1,
      houseNo: "",
      stateCodeSource: {},
    };
  },
  async mounted() {

    this.mainInfo = JSON.parse(this.$route.query.info);
    // this.houseNo = this.$route.params["houseNo"];
      console.log(this.mainInfo);
    this.currentPage = this.mainInfo.page;
    this.stateCodeSource = await this.fetchStateCodeListAsync();
    this.query();
  },
  methods: {
    ...mapActions(["fetchStateCodeListAsync"]),
    //获取状态名称本地语言
    getStateNameLocalLanguage(record) {
      var lang = this.$store.getters.lang;
      var state = {
        en: record.state_ename,
        "zh-cn": record.state_sname,
        "zh-tw": record.state_cname,
      };
      return state[lang];
    },
    changePage(page) {
      if (this.currentPage == page) {
        return;
      }
      this.currentPage = page;
      this.mainInfo.page=page;
      this.query();
    },
    async query() {
      if (this.$utils.isNullOrEmpty(this.mainInfo)) {
        return;
      }
      var self = this;
      await SelectBranchBillOfLading(this.mainInfo)
        .then((res) => {
          //  console.log("进来了成功方法")
          // localStorage.setItem("token",res.data.token);
          // //console.log(localStorage.getItem("token"))
          // _this.SET_LOGIN_USER(res.data);
          //   _this.$router.push({ path: "home" });
          if (res.code == 200) {
            // console.log(self.records);
            self.records = res.data.listTo;
            self.total = res.data.totalLength;
          } else {
            //localStorage.setItem("token",res.data.token);
            //self.SET_LOGIN_USER(res.data);
            // self.$router.push({ path: "home" });
          }
        })
        .catch((error) => {
          console.error(error);
        });

      // await getBillOfLadingRecordDetail({
      //   houseNo: this.houseNo,
      //   page: this.currentPage,
      //   row: 50,
      // })
      //   .then((res) => {
      //     if (res.message) {
      //       alert(res.message);
      //     } else {
      //       self.records = res.data.listTo;
      //       self.total = res.data.totalLength;
      //       window.scrollTo(0, 0);
      //     }
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    masterNo(item) {
      if(this.mainInfo.AwbBlType=="S"){
      this.$router.push({
        name: "branch-bill-of-lading-query-Awbdeatils",
        query: {
          HouseNo: item.houseNo,        
        },
      });
      }
      if(this.mainInfo.AwbBlType=="A"){
       this.$router.push({
        name: "branch-bill-of-lading-query-Bldeatils",
        query: {
          HouseNo: item.houseNo,          
        },
      });
      }
      
    },
    details(item){
       this.$router.push({
        name: "branch-bill-of-lading-query-list-deatils",
        query: {
          HouseNo: item.houseNo,   
          AwbBlType:this.mainInfo.AwbBlType   
        },
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/index.css";
</style>